import React, { useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { Row, Typography, Modal, message, Form } from "antd";
import { useMutation } from "react-query";
import { AxiosEmployeeAPI } from "../Api";
import EmployeeTerminationModalInfo from "../EmployeeTerminationModalInfo";
import EmployeeTerminationModalForm from "./EmployeeTerminationModalForm";
import moment from "moment";
import { PoweroffOutlined } from "@ant-design/icons";
import ActionsModal from "../../common/components/ActionsModal";

export const EmployeeManagerTerminateModal = ({ employee, reload }) => {
  const { Title } = Typography;
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const terminateEmployee = useMutation(
    ["terminate_employee"],
    (values) =>
      AxiosEmployeeAPI.terminateEmployee({
        employee_code: employee.id,
        end_date: moment(values.date).format("YYYY-MM-DD"),
        type: values.termination_type,
        reason: values.reasons,
      }, {}),
    {
      onSuccess: () => {
        message.success("Requisição de desligamento realizada com sucesso!");
        form.resetFields();
        reload();
        setOpen(false);
      },
      onError: () =>
        message.error(
          "Não foi possível realizar a solicitação de desligamento!",
        ),
    },
  );

  const onCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  const handleFormSubmit = () => {
    const values = form.getFieldsValue();
    terminateEmployee.mutate(values);
  };

  return (
    <>
      <ActionsModal
        isModalOpen={confirmModalOpen}
        setIsModalOpen={setConfirmModalOpen}
        onSubmit={handleFormSubmit}
        form={form}
        context={"Atenção"}
      >
        <Typography.Paragraph>
          O funcionário perderá acesso aos sistemas a partir da data de
          desligamento e será registrado como inativo.
        </Typography.Paragraph>
      </ActionsModal>
      <Dropdown.Item
        text="Desligar funcionário"
        icon={<PoweroffOutlined style={{ marginRight: "11px" }} />}
        onClick={() => setOpen(true)}
      />
      <Modal
        open={open}
        title={"Desligar funcionário"}
        okText={"Confirmar"}
        cancelText={"Cancelar"}
        onCancel={onCancel}
        onOk={() =>
          form
            .validateFields()
            .then((values) => {
              setConfirmModalOpen(true);
            })
            .catch((e) =>
              message.error("Preencha todos os campos obrigatórios!"),
            )
        }
        width={800}
      >
        <Row>
          <Title level={2}>{employee.name}</Title>
        </Row>
        <Row style={{ width: "100%" }}>
          <EmployeeTerminationModalInfo employee={employee} />
        </Row>
        <Row>
          <EmployeeTerminationModalForm form={form} />
        </Row>
      </Modal>
    </>
  );
};
